var map = {
	"./allFeatures.svg": 5901,
	"./back.svg": 9306,
	"./blur.svg": 7972,
	"./business.svg": 2445,
	"./card.svg": 8689,
	"./clipart.svg": 8148,
	"./close.svg": 8061,
	"./doodle.svg": 16,
	"./filters.svg": 7536,
	"./left.svg": 7868,
	"./next.svg": 6268,
	"./onTheSpotPrecheck.svg": 5080,
	"./overlay.svg": 9893,
	"./right.svg": 4611,
	"./sketch.svg": 335,
	"./smc.svg": 1362,
	"./standard.svg": 5828,
	"./textOnImage.svg": 8432,
	"./vertical.svg": 2197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6361;